import React from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import UnitInput from "../../parts/inputs/unit-input";

// function View (props, { locals }) {
class View extends React.Component {
  constructor(props, ctx) {
    super(props, ctx);
    this.state = {
      units: "metric",
    };
  }

  handleUnitsChange(to) {
    this.setState({ units: to });
    this.props.locals.units = to;
  }

  render() {
    const { locals } = this.context;
    const { activeUser, momentTZ } = locals;

    const thisYear = momentTZ().year();
    const [first_name, last_name] = _.get(activeUser, "name", " ").split(/ +/);
    return (
      <div id="login-wrapper">
        <form action="/dashboard/settings/profile" method="POST" data-noreset>
          <input
            type="hidden"
            name="redirect"
            value="/dashboard/calendar?firstLogin=true"
          />
          <input type="hidden" name="first_name" value={first_name} />
          <input type="hidden" name="last_name" value={last_name} />
          <input type="hidden" name="setup" value="finished" />
          <input type="hidden" name="firstLogin" value="true" />

          <img
            className="logo"
            src="/img/msb-logo-white.svg"
            alt="My Strength Book"
          />

          <div className="Steps" data-step="4">
            <div className="step" />
            <div className="step" />
            <div className="step" />
            <div className="step" />
          </div>

          <div className="frame">
            <div className="head">
              <h1 className="alt">Personal Details</h1>
              <p>
                Enter the following details so we can accurately calculate your
                training metrics.
              </p>
            </div>

            <div className="columns">
              <div className="column" data-col="1/2">
                <div className="label">
                  Date of birth <span className="required-input">*</span>
                </div>
                <select
                  required
                  name="birthday[month]"
                  className="select-input"
                  defaultValue=""
                >
                  <option disabled hidden value="">
                    Month
                  </option>
                  {_.map(_.range(1, 13), (month) => {
                    return (
                      <option key={month} value={month}>
                        {momentTZ(month, "M").format("MMMM")}
                      </option>
                    );
                  })}
                </select>
              </div>

              <div className="column" data-col="1/4">
                <div className="label hide-responsive">&nbsp;</div>
                <select
                  required
                  name="birthday[day]"
                  className="select-input"
                  defaultValue=""
                >
                  <option disabled hidden value="">
                    Day
                  </option>
                  {_.map(_.range(1, 32), (day) => {
                    return (
                      <option key={day} value={day}>
                        {day}
                      </option>
                    );
                  })}
                </select>
              </div>

              <div className="column" data-col="1/4">
                <div className="label hide-responsive">&nbsp;</div>
                <select
                  required
                  name="birthday[year]"
                  className="select-input"
                  defaultValue=""
                >
                  <option disabled hidden value="">
                    Year
                  </option>
                  {_.map(
                    _.range(
                      momentTZ().subtract(100, "years").year(),
                      momentTZ().subtract(10, "years").year()
                    ),
                    (year) => {
                      return (
                        <option key={year} value={year}>
                          {year}
                        </option>
                      );
                    }
                  ).reverse()}
                </select>
              </div>

              <div className="column" data-col="1/2">
                <div className="label">
                  Gender <span className="required-input">*</span>
                </div>
                <select
                  required
                  name="gender"
                  className="select-input"
                  defaultValue=""
                >
                  <option disabled hidden value="">
                    Gender
                  </option>
                  <option value="male">Male</option>
                  <option value="female">Female</option>
                </select>
              </div>

              <hr />

              <div className="column" data-col="1/1">
                <div className="label radio-label">
                  Preferred measurement system
                </div>
                <label className="radio-input">
                  <input
                    type="radio"
                    name="units"
                    defaultChecked
                    onClick={() => this.handleUnitsChange("metric")}
                    defaultValue="metric"
                  />
                  <span className="radio" />
                  <span className="text">Metric (kg)</span>
                </label>
                <label className="radio-input">
                  <input
                    type="radio"
                    name="units"
                    onClick={() => this.handleUnitsChange("imperial")}
                    defaultValue="imperial"
                  />
                  <span className="radio" />
                  <span className="text">Imperial (lbs)</span>
                </label>
              </div>

              <div className="column" data-col="1/1">
                <div className="label radio-label">
                  Default loading parameter
                </div>
                <label className="radio-input">
                  <input
                    type="radio"
                    name="preferredLoadInput"
                    defaultChecked
                    defaultValue="percent"
                  />
                  <span className="radio" />
                  <span className="text">% of 1RM</span>
                </label>
                <label className="radio-input">
                  <input
                    type="radio"
                    name="preferredLoadInput"
                    defaultValue="weight"
                  />
                  <span className="radio" />
                  <span className="text">Weight</span>
                </label>
              </div>
            </div>

            <hr className="hr-no-columns" />

            <div className="column" data-col="1/1">
              <div className="label" style={{ marginBottom: "-20px" }}>
                Rep Maximum (RM)
              </div>
            </div>

            <div className="column" data-col="1/3">
              <div className="movement-label squat-color">Squat 1RM</div>
              <UnitInput
                required
                min="1"
                metric="kg"
                imperial="lb"
                units={this.state.units}
                className="text-input"
                name="repMaximums[squat]"
                placeholder=""
              />
            </div>

            <div className="column" data-col="1/3">
              <div className="movement-label bench-color">Bench 1RM</div>
              <UnitInput
                required
                min="1"
                metric="kg"
                units={this.state.units}
                imperial="lb"
                className="text-input"
                name="repMaximums[bench]"
                placeholder=""
              />
            </div>

            <div className="column" data-col="1/3">
              <div className="movement-label deadlift-color">Deadlift 1RM</div>
              <UnitInput
                required
                min="1"
                metric="kg"
                imperial="lb"
                units={this.state.units}
                className="text-input"
                name="repMaximums[deadlift]"
                placeholder=""
              />
            </div>

            <div className="column" data-col="1/2">
              <div className="label">
                Current Body Weight <span className="required-input">*</span>
              </div>
              <UnitInput
                required
                metric="kg"
                imperial="lb"
                className="text-input"
                name="weight"
                min="1"
                placeholder="Body weight"
                units={this.state.units}
              />
            </div>

            <hr className="hr-no-columns" />

            <div className="foot">
              <button className="button-input full" type="submit">
                Get Started
              </button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

View.contextTypes = { locals: PropTypes.object };

const Step3 = (app) => {
  app.get("/step3", ({ res, locals }, next) => {
    res.body = <View locals={locals} />;
  });
};

export default Step3;
